export const environment = {
  name: "production",
  production: true,
  hubspotClientId: '69381a0e-2922-44b7-b30a-8e207c0f599e',
  intercomClientId: 'b648b8ab-1138-43c0-9a02-bbe73798c1f5'
};
